import type { MotionProps } from 'framer-motion';

const isPlainObject = (value: unknown) =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const disableSingleAnimationPropDurations = (
  inputAnimation: Record<string, unknown>,
  propName: string
) =>
  Object.entries(inputAnimation).reduce(
    (acc, [key, value]) => {
      if (
        (key === 'duration' || key === 'delay') &&
        typeof value === 'number'
      ) {
        acc[key] = 0;
      } else if (isPlainObject(value)) {
        acc[key] = disableSingleAnimationPropDurations(
          value as Record<string, unknown>,
          key
        );
      } else {
        acc[key] = value;
      }
      return acc;
    },
    {
      ...(propName === 'transition' ? { duration: 0 } : {}),
    } as Record<string, unknown>
  );

const disableAnimationPropsDurations = (
  animationProps: MotionProps
): MotionProps => {
  const newProps = (
    Object.keys(animationProps) as (keyof MotionProps)[]
  ).reduce<MotionProps>(
    (acc, key) => {
      const value = animationProps[key];

      if (isPlainObject(value)) {
        acc[key] = disableSingleAnimationPropDurations(
          value as Record<string, unknown>,
          key
        );
      }

      return acc;
    },
    { ...animationProps }
  );

  return {
    ...newProps,
    transition: { ...(newProps.transition || {}), duration: 0 },
  };
};

export default disableAnimationPropsDurations;
